import {Component, ElementRef, NgZone, OnInit, ViewChild, HostListener} from '@angular/core';
import {LocationAutocompleteItemData} from '../../../models/commons/interfaces';
import {LocationService} from '../../services/location.service';
import {RestService} from '../../services/rest.service';
import {LoadingController, NavController, Platform, ToastController} from '@ionic/angular';
import {ActivatedRoute} from '@angular/router';
import {Location} from "@angular/common";
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
// Pixel library importing
import { PixelService } from 'ngx-pixel';
import {QuillEditorComponent} from 'ngx-quill';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-post-music',
  templateUrl: './post-music.page.html',
  styleUrls: ['./post-music.page.scss'],
})
export class PostMusicPage implements OnInit {
  @ViewChild('popoverEditImage') popoverEditImage;
  loadMostWanted: any;
  isMobile: boolean;
  searchTop: any;
  helpFocus: boolean;
  showOverSearch: boolean;
  location: string;
  locationsAutocomplete: any[] = [];
  availableAgeRanges: any[] = [];
  availableLevels: any[] = [];
  availableLevelsServices: any[] = [];
  availablePeriodicities: any[] = [];
  availableTypeServices: any[] = [];
  availablePriceTypes: any[] = [];
  availableInstruments: any[] = [];
  availableCurrency = '';
  availableCategoriesClasses: any[] = [];
  availableCategoriesClassesInstruments: any[] = [];
  availableSubtypeServicePerID1: any[] = [];
  availableSubtypeServicePerID2: any[] = [];
  availableSubtypeServicePerID4: any[] = [];
  availableSubtypeServicePerID8: any[] = [];

  profile: any;
  instrumentsList: string[] = [];
  selectedLocation: {
    place_id: string;
    latitude: any;
    longitude: any;
    country: string;
    administrative_area_level_1: string;
    administrative_area_level_2: string;
    locality: string;
  };

  center: google.maps.LatLngLiteral = {lat: 24, lng: 12};
  zoom = 4;
  markerOptions: google.maps.MarkerOptions = {draggable: false};
  markerPositions: google.maps.LatLngLiteral[] = [];
  next = false;
  modalShow: boolean;
  user: any;
  postType: string;
  customPopoverOptions: any = {
    cssClass: 'pop-select-post'
  };
  showMapUbication: boolean;
  selectedTypeService: any;
  selectedCategoryClass: any;
  tittleQuill: string;
  localCurrencyPrice: number;
  internationalCurrencyPrice: number;
  descriptionQuill: string;
  selectedPeriodicitiesLesson: any;
  selectedPriceType: any;
  bringInstrument: boolean;
  atHome: boolean;
  online: boolean;
  inPlace: boolean;
  checkSessionist: boolean;
  checkBandSearch: boolean;
  checkLiveSound: boolean;
  checkHomeStudio: boolean;
  selectedInstrumentService: any[] = [];
  selectedInstrumentServiceGet: any[] = [];
  base64textString: string[] = [];
  urlInputVideo: boolean;
  urlVideo: any[] = [{valor: ''}];
  id: number;
  imageUpload: any;
  modalUpload: boolean;
  selectedFiles: any[] = [];
  selectedFilesBase64: any[] = [];
  filesBase64: any[] = [];
  isOpenEditImage: boolean;
  private dataImage: any;
  coverImage: number;
  linksEmbedYoutube: SafeUrl[] = [];
  linksEmbedVimeo: SafeUrl[] = [];
  auxUrlVideo: any[] = [{valor: ''}];
  deleteImageEdit: number[];
  imageIds: number[];
  categoryRequired: boolean = false;
  quillRequired: boolean = false;
  priceRequired: boolean = false;
  publishRequired: boolean = false;
  anyForm : boolean = false;

  constructor(
    public locationService: LocationService,
    public zone: NgZone,
    public rest: RestService,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    private router: ActivatedRoute,
    public elementRef: ElementRef,
    public platform: Platform,
    private locationRouter: Location,
    private sanitizer: DomSanitizer,
    private pixel: PixelService,
     private translate: TranslateService,
    private toastController: ToastController,
  ) {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.isMobile = true;
    }
  }

  ngOnInit() {
    this.clearForm();
    this.router.params.subscribe(params => {
      this.id = params['id'];
      this.postType = this.router.snapshot.routeConfig.path;
      if (this.id) {
        this.getDataEditPost();
      } else {
        this.loadData();
      }
    });
  }

  ionViewDidEnter() {
    this.clearForm();
    this.router.params.subscribe(params => {
      this.id = params['id'];
      this.postType = this.router.snapshot.routeConfig.path;
      if (this.id) {
        this.getDataEditPost();
      } else {
        this.loadData();
      }
    });
  }

  private loadData() {
    this.rest.getStorage('user').then((val) => {
      this.user = val;
      console.log(val);
      if (!val) {
        this.navCtrl.navigateRoot('login');
      } else {
        //this.loadDataProfile(); // TODO: quitar esto, no se utiliza aqui
      }
    });
    this.getAgeRanges();
    this.getLevels();
    this.getPeriodicities();
    this.getLevelsServices();
    this.getTypeService();
    this.getSubTypeService();
    this.getPeriodicitiesServices();
    this.getInstruments();
    this.getCurrency();
    this.getCategoriesClass();
    this.next = false;
  }

  async loadDataProfile() {
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();
    this.rest._get('accounts/user-information/' + this.user.user_id, 'get').subscribe(response => {
      this.profile = response.body;
      this.getExtendedProfile();
      auxLoading.dismiss();
    }, (err) => {
      if (auxLoading) {
        auxLoading.dismiss();
      }
      console.error('There was an error loading this data', err);
    });
  }

  outData2(ev) {
    //console.log(ev);
    if (ev.banners) {
      // this.banners = ev.banners
    }
    if (ev && ev.blur) {
      this.showOverSearch = false;
      this.searchTop = null;
      this.helpFocus = false;
    }
  }

  fetchLocations() {
    if (this.location === '') {
      this.locationsAutocomplete = [];
      this.selectedLocation = {
        place_id: '',
        latitude: undefined,
        longitude: undefined,
        country: '',
        administrative_area_level_1: '',
        administrative_area_level_2: '',
        locality: '',
      };
      return;
    }

    this.locationService.fetchLocations(this.location).then(
      (predictions: Array<LocationAutocompleteItemData>) => {
        console.info(predictions);
        this.locationsAutocomplete = [];

        if (predictions) {
          this.zone.run(() => {
            predictions.forEach((prediction) => {
              this.locationsAutocomplete.push(prediction);
            });
          });
        }
      }
    );
  }

  handleLocation(e) {
    this.publishRequired = false;
  }

  public selectLocation(item: LocationAutocompleteItemData) {
    this.location = item.description;
    this.locationsAutocomplete = [];

    this.locationService.selectLocation(item.place_id).then((location) => {
      this.selectedLocation = location;
      this.zoom = 12;
      this.center = {lat: location.latitude, lng: location.longitude};
      this.markerPositions = [new google.maps.LatLng({lat: location.latitude, lng: location.longitude}).toJSON()];
    }).catch((err) => console.error(err));
  }

  getCurrentLocation(doSearch?: boolean) {
    this.locationService.getCurrentLocation().then((currentLocation) => {
      this.selectedLocation = {
        place_id: currentLocation.place_id,
        latitude: currentLocation.latitude,
        longitude: currentLocation.longitude,
        country: currentLocation.country,
        administrative_area_level_1: currentLocation.administrative_area_level_1,
        administrative_area_level_2: currentLocation.administrative_area_level_2,
        locality: currentLocation.locality,
      };

      this.location = currentLocation.location;
    }).catch((err) => {
      console.error(err);
    });
  }

  addMarker(event: google.maps.MapMouseEvent) {
    this.markerPositions = [event.latLng.toJSON()];
    this.locationService.getLocation(event.latLng).then(response => {
      this.location = response.location;
      this.selectedLocation = response;
    });
  }

  nextStep() {
    if (!this.selectedTypeService && !this.selectedCategoryClass) {
      this.categoryRequired = true;
    }
    if ((!this.tittleQuill && !this.descriptionQuill)) {
      this.quillRequired = true;
    }
    if (this.validPrice() && !this.localCurrencyPrice && !this.internationalCurrencyPrice) {
      this.priceRequired = true;
    }
    if (this.valid()) {
      this.scrolltoTop();
      this.next = !this.next;
    }
  }

  anyFormFull() {
    if (this.selectedTypeService || this.selectedCategoryClass || this.tittleQuill || this.descriptionQuill || this.localCurrencyPrice || this.internationalCurrencyPrice || this.selectedPriceType || this.selectedPeriodicitiesLesson || this.online || this.inPlace) {
      return true;
    } else {
      return false;
    }
  }

  canDeactivate(): boolean {
    if(this.anyFormFull()) {
      return window.confirm(this.translate.instant('SURE_LEAVE'));
    }
    return true;
  }
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    if (this.anyFormFull()) {
      $event.returnValue = true;
    }
  }

  valid() {
    return ((this.selectedTypeService || this.selectedCategoryClass) && this.tittleQuill && this.descriptionQuill)
      && (((this.selectedPriceType || this.selectedPeriodicitiesLesson) && (this.localCurrencyPrice || this.internationalCurrencyPrice))
        || (!this.selectedPriceType && !this.selectedPeriodicitiesLesson && !this.localCurrencyPrice && !this.internationalCurrencyPrice));
  }

  valid2() {
    return (this.online || this.inPlace);
  }

  validPrice() {
    return (this.selectedPriceType || this.selectedPeriodicitiesLesson);
  }

  prevStep() {
    this.scrolltoTop();
    this.next = !this.next;
  }

  showModal() {
    this.modalShow = !this.modalShow;
  }

  getAgeRanges() {
    return this.rest._get('lessons/ages').subscribe((resespone: any) => {
      let allRanges = resespone.body.data.ages.map(age => ({...age, selected: false}));
      allRanges = allRanges.filter(al => this.availableAgeRanges.findIndex(value => value.name === al.name) === -1);
      this.availableAgeRanges = this.availableAgeRanges.concat(allRanges);
      return this.availableAgeRanges;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getLevels() {
    return this.rest._get('lessons/levels').subscribe((resespone: any) => {
      let allLevels = resespone.body.data.levels.map(level => ({...level, selected: false}));
      allLevels = allLevels.filter(al => this.availableLevels.findIndex(value => value.name === al.name) === -1);
      this.availableLevels = this.availableLevels.concat(allLevels);
      return this.availableLevels;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getLevelsServices() {
    return this.rest._get('services/levels').subscribe((resespone: any) => {
      let allLevels = resespone.body.data.levels.map(level => ({...level, selected: false}));
      allLevels = allLevels.filter(al => this.availableLevelsServices.findIndex(value => value.name === al.name) === -1);
      this.availableLevelsServices = this.availableLevelsServices.concat(allLevels);
      return this.availableLevelsServices;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getPeriodicities() {
    return this.rest._get('lessons/periodicities').subscribe((resespone: any) => {
      this.availablePeriodicities = resespone.body.data.periodicities;

      if (this.selectedPeriodicitiesLesson) {
        this.selectedPeriodicitiesLesson = this.availablePeriodicities.find(value => value.periodicity_id === this.selectedPeriodicitiesLesson);
      }
      return this.availablePeriodicities;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getPeriodicitiesServices() {
    return this.rest._get('services/price-types').subscribe((resespone: any) => {
      this.availablePriceTypes = resespone.body.data.prices;
      if (this.selectedPriceType) {
        this.selectedPriceType = this.availablePriceTypes.find(value => value.price_type_id === this.selectedPriceType.price_type_id);
      }
      return this.availablePriceTypes;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getTypeService() {
    return this.rest._get('services/user-types').subscribe((resespone: any) => {
      this.availableTypeServices = resespone.body.items;

      if (this.selectedTypeService) {
        this.selectedTypeService = this.availableTypeServices.find(value => value.user_type_id === this.selectedTypeService.user_type_id);
      }

      return this.availableTypeServices;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getSubTypeService() {
    return this.rest._get('services/user-service-types').subscribe((resespone: any) => {
      this.availableSubtypeServicePerID1 = resespone.body.items.filter(filterId => filterId.user_type_id === 1)
        .map(checked => ({...checked, selected: false}));
      this.availableSubtypeServicePerID2 = resespone.body.items.filter(filterId => filterId.user_type_id === 2)
        .map(checked => ({...checked, selected: false}));
      this.availableSubtypeServicePerID4 = resespone.body.items.filter(filterId => filterId.user_type_id === 4)
        .map(checked => ({...checked, selected: false}));
      this.availableSubtypeServicePerID8 = resespone.body.items.filter(filterId => filterId.user_type_id === 8)
        .map(checked => ({...checked, selected: false}));
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getCategoriesClass() {
    return this.rest._get('lessons/categories').subscribe((resespone: any) => {
      this.availableCategoriesClasses = resespone.body.filter(category => category.parent == null);
      this.availableCategoriesClassesInstruments = resespone.body.filter(intruments => intruments.parent != null);

      if (this.selectedCategoryClass) {
        this.selectedCategoryClass = this.availableCategoriesClasses.find(value => value.category_id === this.selectedCategoryClass.category_id);
      }
      if (this.selectedInstrumentService) {
        this.selectedInstrumentService = this.availableCategoriesClassesInstruments.find(value => value.instruments?.instrument_id === this.selectedInstrumentService);
      }
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getExtendedProfile() {
    let requestProfile = '';
    for (let i = 0; i < this.profile.profiles.length; i++) {
      requestProfile = requestProfile + this.profile.profiles[i].name;
      if ((this.profile.profiles.length - 1) !== i) {
        requestProfile = requestProfile + '.';
      }
    }
    this.rest._get('profile/fields/' + requestProfile + '/' + this.profile.user_id).subscribe((response: any) => {
      this.getProfileInstruments(response.body);
    }, (error) => {
      console.error('error: ', error);
    });
  }

  private getProfileInstruments(extendedProfile: any) {
    let instrumentsProfile = extendedProfile.fields.find(g => (g.fields && g.fields.length > 0 && g.fields[0].label === 'Instrumentos'));
    if (instrumentsProfile) {
      instrumentsProfile = instrumentsProfile.fields[0];
      try {
        const parsedInstrumentList = JSON.parse(instrumentsProfile.values);
        this.instrumentsList = parsedInstrumentList.map(i => i.instrument);
      } catch (e) {
        this.instrumentsList = [];
      }
    }
  }

  getInstruments() {
    return this.rest._get('fields/values/instruments').subscribe((resespone: any) => {
      this.availableInstruments = resespone.body.values.map(instrument => ({...instrument}));
      if (this.selectedInstrumentService) {
        this.selectedInstrumentService = this.availableInstruments.find(value => value.instruments?.instrument_id === this.selectedInstrumentService);
      }
      return this.availableInstruments;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  getCurrency() {
    return this.rest._get('user-currencies').subscribe((resespone: any) => {
      this.availableCurrency = resespone.body;
      return this.availableCurrency;
    }, (error) => {
      console.error('error: ', error);
    });
  }

  gotoHome() {
    if(this.canDeactivate()){
      this.clearForm();
      this.navCtrl.navigateForward('/home');
    }
  }

  gotoHomeReady() {
    this.clearForm();
    this.navCtrl.navigateForward('/home');
  }

  private clearForm() {
    this.tittleQuill = null;
    this.descriptionQuill = null;
    //this.selectedPeriodicitiesLesson.periodicity_id = null;
    this.availableCurrency = null;
    this.localCurrencyPrice = null;
    this.internationalCurrencyPrice = null;
    //////////////////////////////
    this.availableLevels = [];
    this.availableAgeRanges = [];
    this.bringInstrument = null;
    this.atHome = null;
    this.selectedLocation = null;
    this.urlVideo = [{valor: ''}];
    this.auxUrlVideo = [{valor: ''}];
    this.filesBase64 = [];
    this.selectedFilesBase64 = [];
    this.selectedPriceType = null;
    this.checkSessionist = false;
    this.checkBandSearch = false;
    this.checkLiveSound = false;
    this.checkHomeStudio = false;
    this.modalShow = false;
    this.showMapUbication = false;
    this.next = false;
    this.coverImage = null;
    this.deleteImageEdit = [];
    this.dataImage = null;
    this.selectedTypeService = null;
    this.selectedCategoryClass = null;
    this.categoryRequired = false;
    this.quillRequired = false;
    this.priceRequired = false;
    this.publishRequired = false;
    this.inPlace = false;
    this.online = false;
  }

  outData(ev) {
    if (ev && ev.editProfile) {
      this.navCtrl.navigateForward('mi-perfil');
    }

    if (ev && ev.focus) {
      this.showOverSearch = true;
      if (ev.search === '') {
        this.searchTop = '';
      }
      setTimeout(() => {
        this.helpFocus = true;
      }, 1800);
    }

    if (ev && ev.login) {
      // this.openLogin();
      this.navCtrl.navigateRoot('/login')
    }

    if (ev && ev.home) {
      let url = '/home';
      this.locationRouter.go(url);
    }

    if (ev && ev.referred) {
      let url = '/referred';
      this.navCtrl.navigateRoot(url);
    }

    if (ev && ev.old) {
      // this.navCtrl.navigateRoot('/registro')
      this.gotoOldApp(ev.view);
    }


    if (ev && ev.search) {
      console.log(ev.search);
      this.searchTop = ev.search;

    }

    if (ev && typeof ev.isMobile === 'boolean') {
      // console.log(ev);
      this.isMobile = ev.isMobile;
    }

  }

  gotoOldApp(view?) {
    console.log(view);

    if (view) {
      this.navCtrl.navigateForward(view);
    } else {
      window.open('https://louderband.com/', '_self');
    }
  }

  handleServiceTypeChange(e: any) {
    this.selectedTypeService = e.detail.value;
    this.categoryRequired = false;
  }

  handleClassCategoryChange(e: any) {
    this.selectedCategoryClass = e.detail.value;
    this.categoryRequired = false;
  }

  handlePeriodicitiesLesson(e: any) {
    this.selectedPeriodicitiesLesson = e.detail.value;
  }

  handlePriceType(e: any) {
    this.selectedPriceType = e.detail.value;
  }

  handleInstrumentService(e: any) {
    this.selectedInstrumentService = e.detail.value;
    console.log(this.selectedInstrumentService);
  }

  handleCurrency(e: any) {
    this.priceRequired = false;
  }

  handleQuill(e: any) {
    if (this.descriptionQuill !== '' && this.tittleQuill !== '') {
      this.quillRequired = false;
    }
  }

  scrolltoTop(): void {
    const top = this.elementRef.nativeElement.querySelector('#top');
    top.scrollIntoView({behavior: 'smooth'});
  }

  uploadPhoto($event): void {
    this.imageUpload = $event.target.files[0];

    if (this.imageUpload) {
      const reader = new FileReader();

      reader.onload = this.handleReaderLoaded.bind(this);
      reader.readAsBinaryString(this.imageUpload);
    }
  }

  handleReaderLoaded(e) {
    this.base64textString = ['data:image/png;base64,' + btoa(e.target.result)];
  }

  showUrlVideo() {
    this.urlInputVideo = !this.urlInputVideo;
  }

  handleClassOrService(e: any) {
    this.publishRequired = false;
  }

  async publishLessons() {
    if(!this.online && (!this.inPlace && !this.selectedLocation)){
      this.publishRequired = true;
    } else if(this.online || (this.inPlace && this.selectedLocation)) {
      const covertToArrayVideo = this.urlVideo.map((video) => video.valor).filter((video) => video !== '');
      const data = {
        images_remove: this.deleteImageEdit ? this.deleteImageEdit : [],
        images: this.filesBase64.filter(value => value.startsWith('data:image/')),
        videos: covertToArrayVideo ? covertToArrayVideo : [],
        category_id: this.selectedCategoryClass.category_id,
        title: this.tittleQuill,
        description: this.descriptionQuill,
        periodicity_id: this.selectedPeriodicitiesLesson?.periodicity_id,
        currency_local: this.availableCurrency,
        price_local: this.localCurrencyPrice,
        price: this.internationalCurrencyPrice,
        levels: this.availableLevels.filter(level => level.selected).map(level => level.level_id),
        age_ranges: this.availableAgeRanges.filter(age => age.selected).map(age => age.age_range_id),
        bring_instrument: this.bringInstrument ? 'S' : 'N',
        at_home: this.atHome ? 'S' : 'N',
        place_id: this.selectedLocation && this.selectedLocation.place_id ? this.selectedLocation.place_id : 0,
        latitude: this.selectedLocation ? this.selectedLocation.latitude : '',
        longitude: this.selectedLocation ? this.selectedLocation.longitude : '',
        country: this.selectedLocation ? this.selectedLocation.country : '',
        administrative_area_level_1: this.selectedLocation ? this.selectedLocation.administrative_area_level_1 : '',
        administrative_area_level_2: this.selectedLocation ? this.selectedLocation.administrative_area_level_2 : '',
        locality: this.selectedLocation ? this.selectedLocation.locality : '',
        online: this.online ? 'S' : 'N',
        instruments_selected: this.selectedInstrumentService ? this.selectedInstrumentService.map(value => ({ instrument_id: value.category_id})) : [],
      };
      const auxLoading = await this.loadingCtrl.create({});
      await auxLoading.present();
      if (this.id) { // Editar
        this.rest._post('lessons/lessons/' + this.id, data).subscribe(async (resesponeEdit: any) => {
          console.log(resesponeEdit.body);
          if (this.coverImage !== null) {
            const lessonId = resesponeEdit.body.map((service) => service.lesson_id);
            const imageCover = resesponeEdit.body.map((image) => image.images_ids[this.coverImage].id);
            const dataCoverImageEdit = {
              lesson_id: lessonId.pop(),
              resource_id: imageCover.pop(),
            };
            this.rest._post('lessons/set-main-image', dataCoverImageEdit).subscribe(async (resesponeCoverImageEdit: any) => {
              console.log('RESPONSE BODY', resesponeCoverImageEdit.body);
              await auxLoading.dismiss();
              this.showModal();
            }, async (error) => {
              console.error('error: ', error);
              await auxLoading.dismiss();
            });
          } else {
            await auxLoading.dismiss();
            this.showModal();
          }
        }, async (error) => {
          await auxLoading.dismiss();
          console.error('error: ', error);
        });
      } else { // Crear
        this.rest._post('lessons/lessons', data).subscribe(async (resesponeNew: any) => {
          console.log(resesponeNew.body);
          if (this.coverImage !== null) {
            const lessonId = resesponeNew.body.map((service) => service.lesson_id);
            const imageCover = resesponeNew.body.map((image) => image.images_ids[this.coverImage].id);
            const dataCoverImageNew = {
              lesson_id: lessonId.pop(),
              resource_id: imageCover.pop(),
            };
            this.rest._post('lessons/set-main-image', dataCoverImageNew).subscribe(async (resesponeCoverImageNew: any) => {
              console.log('RESPONSE BODY', resesponeCoverImageNew.body);
              await auxLoading.dismiss();
              this.showModal();
            }, async (error) => {
              console.error('error: ', error);
              await auxLoading.dismiss();
            });
          } else {
            await auxLoading.dismiss();
            this.showModal();
          }
        }, async (error) => {
          await auxLoading.dismiss();
          console.error('error: ', error);
        });
      }
    }
  }

  async publishServices() {
    if(!this.online && (!this.inPlace && !this.selectedLocation)){
      this.publishRequired = true;
    } else if(this.online || (this.inPlace && this.selectedLocation)){
      let availableSubtypeService: number[] = [];
      if (this.selectedTypeService.auth_item_id === 'estudio') {
        availableSubtypeService = this.availableSubtypeServicePerID1.filter(checked => checked.selected)
          .map(checked => checked.service_types.service_type_id);
      }
      if (this.selectedTypeService.auth_item_id === 'sonidista') {
        availableSubtypeService = this.availableSubtypeServicePerID2.filter(checked => checked.selected)
          .map(checked => checked.service_types.service_type_id);
      }
      if (this.selectedTypeService.auth_item_id === 'productor') {
        availableSubtypeService = this.availableSubtypeServicePerID4.filter(checked => checked.selected)
          .map(checked => checked.service_types.service_type_id);
      }
      if (this.selectedTypeService.auth_item_id === 'disenador') {
        availableSubtypeService = this.availableSubtypeServicePerID8.filter(checked => checked.selected)
          .map(checked => checked.service_types.service_type_id);
      }
      const covertToArrayVideo = this.urlVideo.map((video) => video.valor).filter((video) => video !== '');
      const data = {
        images_remove: this.deleteImageEdit ? this.deleteImageEdit : [],
        images: this.filesBase64.filter(value => value.startsWith('data:image/')),
        videos: covertToArrayVideo ? covertToArrayVideo : [],
        user_type_id: this.selectedTypeService.user_type_id,
        instruments: this.selectedInstrumentService ? this.selectedInstrumentService.map(inst => inst.id) : [],
        title: this.tittleQuill,
        description: this.descriptionQuill,
        price_type_id: this.selectedPriceType?.price_type,
        currency_local: this.availableCurrency,
        price_local: this.localCurrencyPrice,
        price: this.internationalCurrencyPrice,
        levels: this.availableLevelsServices.filter(level => level.selected).map(level => level.level_id),
        sessionist: this.checkSessionist ? "S" : "N",
        band_search: this.checkBandSearch ? "S" : "N",
        live_sound: this.checkLiveSound ? "S" : "N",
        home_studio: this.checkHomeStudio ? "S" : "N",
        //////////////////////////////////////////////////
        services_types: availableSubtypeService,
        place_id: this.selectedLocation && this.selectedLocation.place_id ? this.selectedLocation.place_id : 0,
        latitude: this.selectedLocation ? this.selectedLocation.latitude : '',
        longitude: this.selectedLocation ? this.selectedLocation.longitude : '',
        country: this.selectedLocation ? this.selectedLocation.country : '',
        administrative_area_level_1: this.selectedLocation ? this.selectedLocation.administrative_area_level_1 : '',
        administrative_area_level_2: this.selectedLocation ? this.selectedLocation.administrative_area_level_2 : '',
        locality: this.selectedLocation ? this.selectedLocation.locality : '',
        online: this.online ? 'S' : 'N',
      };
      const auxLoading = await this.loadingCtrl.create({});
      await auxLoading.present();
      //EDITAR POST
      if (this.id) {
        this.rest._post('services/services/' + this.id, data).subscribe(async (resesponeEdit: any) => {
          console.log(resesponeEdit.body);
          if (this.coverImage !== null) {
            const servicesId = resesponeEdit.body.map((service) => service.service_id);
            const imageCover = resesponeEdit.body.map((image) => image.images_ids[this.coverImage].id);
            const dataCoverImageEdit = {
              service_id: servicesId.pop(),
              resource_id: imageCover.pop(),
            };
            this.rest._post('services/set-main-image', dataCoverImageEdit).subscribe(async (resesponeCoverImageEdit: any) => {
              console.log('RESPONSE BODY', resesponeCoverImageEdit.body);
              await auxLoading.dismiss();
              this.showModal();
            }, async (error) => {
              console.error('error: ', error);
              await auxLoading.dismiss();
            });
          } else {
            await auxLoading.dismiss();
            this.showModal();
          }
        }, async (error) => {
          console.error('error: ', error);
          await auxLoading.dismiss();
        });
      } else { //CREAR POST
        this.rest._post('services/services', data).subscribe(async (resesponeNew: any) => {
          console.log(resesponeNew.body);
          if (this.coverImage !== null) {
            const servicesId = resesponeNew.body.map((service) => service.service_id);
            const imageCover = resesponeNew.body.map((image) => image.images_ids[this.coverImage].id);
            const dataCoverImageNew = {
              service_id: servicesId.pop(),
              resource_id: imageCover.pop(),
            };
            this.rest._post('services/set-main-image', dataCoverImageNew).subscribe(async (resesponeCoverImageNew: any) => {
              console.log('RESPONSE BODY', resesponeCoverImageNew.body);
              await auxLoading.dismiss();
              this.showModal();
            }, async (error) => {
              console.error('error: ', error);
              await auxLoading.dismiss();
            });
          } else {
            await auxLoading.dismiss();
            this.showModal();
          }
        }, async (error) => {
          console.error('error: ', error);
          await auxLoading.dismiss();
        });
      }
    }
  }

  async getDataEditPost() {
    const auxLoading = await this.loadingCtrl.create({});
    await auxLoading.present();
    //this.loadData(); // todo: REVISAR
    let apiHelp: string;
    switch (this.postType) {
      case 'class/:id' :
        const lessons = ('lessons/') + this.id;
        apiHelp = lessons;
        break;
      case 'service/:id' :
        const services = ('services/') + this.id;
        apiHelp = services;
        break;
    }

    this.rest._get(apiHelp).subscribe(async response => {
      const service: any = response.body;
      this.selectedTypeService = this.postType === 'service/:id' ? service.userType : null;
      this.selectedInstrumentService = this.availableInstruments.filter(instrument => service.instruments.map(inst => inst.instrument_id).includes(instrument.id));
      //console.log('servicesssssss3', this.selectedInstrumentService);
      this.selectedCategoryClass = this.postType === 'class/:id' ? service.category : null;
      this.filesBase64 = service.images.map(image => image);
      this.imageIds = service.images_ids.map(image => image.id);
      this.urlVideo = service.videos ? service.videos : [];
      this.tittleQuill = service.title;
      this.descriptionQuill = service.description;
      this.selectedPeriodicitiesLesson = this.postType === 'class/:id' ? service.periodicity_id : null;
      this.selectedPriceType = this.postType === 'service/:id' ? service.price_type_id : null;
      this.localCurrencyPrice = service.price_local;
      this.internationalCurrencyPrice = service.geo_price;
      this.availableAgeRanges = this.postType === 'class/:id' ? service.age_ranges.map(age => ({
        ...age,
        selected: true
      })) : [];
      this.availableLevels = this.postType === 'class/:id' ? service.levels.map(level => ({
        ...level,
        selected: true
      })) : [];
      this.availableLevelsServices = this.postType === 'service/:id' ? service.levels.map(level => ({
        ...level,
        selected: true
      })) : [];
      this.checkSessionist = service.sessionist;
      this.checkBandSearch = service.band_search;
      this.checkLiveSound = service.live_sound;
      this.checkHomeStudio = service.home_studio;
      this.atHome = service.at_home;
      this.bringInstrument = service.bring_instrument;
      this.location = service.short_location;
      this.online = service.online;
      this.inPlace = service.place_id !== '0';
      this.uploadFilesGet();
      this.loadData(); // TODO: AQUI ESTA EL ERROR revisar
      await auxLoading.dismiss();
    }, async (error) => {
      console.error('error: ', error);
      await auxLoading.dismiss();
    });
  }

  openModalUpload() {
    this.modalUpload = true;
    if (this.auxUrlVideo.length > 0 || this.auxUrlVideo.length > 0) {
      this.urlVideo = [...this.auxUrlVideo];
    } else {
      this.urlVideo = [{valor: ''}];
    }
    if (this.filesBase64.length > 0) {
      this.selectedFilesBase64 = [...this.filesBase64];
    } else {
      this.selectedFilesBase64 = [];
    }
  }

  cancelModalUpload() {
    if (this.auxUrlVideo.length === 0) {
      this.urlVideo = [{valor: ''}];
    }
    if (this.filesBase64.length === 0) {
      this.selectedFilesBase64 = [];
    }
    this.modalUpload = false;
  }

  async onFileSelected(event: any) {
    if (this.selectedFilesBase64.length < 5) {
      const files: FileList = event.target.files;
      for (let i = 0; i < files.length && i < 5; i++) {
        const file = files[i];
        this.selectedFiles.push(file);

        const reader = new FileReader();
        reader.onload = (e: any) => {
          const base64Image = e.target.result;
          this.selectedFilesBase64.push(base64Image);
        };
        reader.readAsDataURL(file);
      }
    } else {
      const toast = await this.toastController.create({
        message: this.translate.instant('FIVE_IMAGES'),
        duration: 3000,
        position: 'top',
        color: 'danger',
        icon: 'warning-outline'
      });
      await toast.present();
    }
  }

  uploadFiles() {
    // Aquí implementar la lógica para subir los archivos
    const inputValues = this.urlVideo.map(url => url.valor);
    this.linksEmbedYoutube = inputValues
      .filter(item => item !== '' && (item.includes('youtube') || item.includes('youtu.be')))
      .map(item => this.sanitizer.bypassSecurityTrustResourceUrl(this.buildLinkToEmbed(item)));
    this.linksEmbedVimeo = inputValues
      .filter(item => item !== '' && item.includes('vimeo'))
      .map(item => this.sanitizer.bypassSecurityTrustResourceUrl(this.buildLinkToEmbed(item)));
    this.filesBase64 = [...this.selectedFilesBase64];
    this.auxUrlVideo = [...this.urlVideo];
    console.log('AUXVIDEO', this.auxUrlVideo);
    this.modalUpload = false;
  }

  uploadFilesGet() {
    // Aquí implementar la lógica para subir los archivos
    const inputValuesGet = this.urlVideo;
    this.linksEmbedYoutube = inputValuesGet
      .filter(item => item !== '' && (item.includes('youtube') || item.includes('youtu.be')))
      .map(item => this.sanitizer.bypassSecurityTrustResourceUrl(this.buildLinkToEmbed(item)));
    this.linksEmbedVimeo = inputValuesGet
      .filter(item => item !== '' && item.includes('vimeo'))
      .map(item => this.sanitizer.bypassSecurityTrustResourceUrl(this.buildLinkToEmbed(item)));
    //this.filesBase64 = [...this.selectedFilesBase64];
    this.urlVideo = this.urlVideo.map(item => ({valor: item}));
    this.auxUrlVideo = [...this.urlVideo];
    //this.modalUpload = false;
  }

  addInputVideo() {
    if (this.urlVideo.length < 5) {
      this.urlVideo.push({valor: ''});
    }
  }

  deleteInputVideo(index: number) {
    this.urlVideo.splice(index, 1);
  }

  popoverImageEdit(e: Event, item) {
    this.popoverEditImage.event = e;
    this.isOpenEditImage = true;
    this.dataImage = item;
  }

  coverImageSelected() {
    this.coverImage = this.dataImage;
    this.isOpenEditImage = false;
  }

  deleteImage() {
    if (this.modalUpload) {
      this.selectedFilesBase64.splice(this.dataImage, 1);
    } else {
      this.filesBase64.splice(this.dataImage, 1);
    }
    this.deleteImageEdit = [...this.deleteImageEdit, this.imageIds[this.dataImage]];
    this.isOpenEditImage = false;
  }

  buildLinkToEmbed(value: any) {
    if (value.includes('youtube.com')) {
      const segments = value.split('=');
      const lastSegment = (segments[segments.length - 1]);
      const link = 'https://www.youtube.com/embed/' + lastSegment;
      return value.replace(value, link);
    }
    if (value.includes('youtu.be')) {
      const segments = value.split('/');
      const lastSegment = (segments[segments.length - 1]);
      const link = 'https://www.youtube.com/embed/' + lastSegment;
      return value.replace(value, link);
    }
    if (value.includes('vimeo.com')) {
      const segments = value.split('/');
      const lastSegment = (segments[segments.length - 1]);
      if (lastSegment.includes('?')) {
        const lastSegmentSplit = lastSegment.split('?');
        const link2 = 'https://player.vimeo.com/video/' + lastSegmentSplit[0];
        return value.replace(value, link2);
      }
      const link = 'https://player.vimeo.com/video/' + lastSegment;
      return value.replace(value, link);
    }
  }

  /*textChanged($event) {
    const maxLength = 200;
    if ($event.editor.getLength() > maxLength) {
      $event.editor.deleteText(maxLength, $event.editor.getLength());
    }
  }*/
}
